<template>
  <v-card class="elevation-0">
    <div v-if="packListCritical.length" id="pack-quick-links-criticalList">
      <h3 class="font-weight-thin mt-3">Critical Fixes</h3>
      <ul>
        <li v-for="item in packListCritical" :key="item.id">
          <router-link :to="`/pack/${item.id}/${linkName}/list?page=1`" class="text-caption" data-cy="packQuickLink">{{
            stripPackTitlePrefix(item.title)
          }}</router-link>
        </li>
      </ul>
    </div>
    <div v-if="packListReleaseCycle.length" id="pack-quick-links-releaseList">
      <h3 class="font-weight-thin mt-3">Release Cycle</h3>
      <ul>
        <li v-for="item in packListReleaseCycle" :key="item.id">
          <router-link :to="`/pack/${item.id}/${linkName}/list?page=1`" class="text-caption" data-cy="packQuickLink">{{
            stripPackTitlePrefix(item.title)
          }}</router-link>
        </li>
      </ul>
    </div>
    <div v-if="packListOther.length" id="pack-quick-links-otherList">
      <h3 class="font-weight-thin mt-3">Other</h3>
      <ul>
        <li v-for="item in packListOther" :key="item.id">
          <router-link :to="`/pack/${item.id}/${linkName}/list?page=1`" class="text-caption" data-cy="packQuickLink">{{
            stripPackTitlePrefix(item.title)
          }}</router-link>
        </li>
      </ul>
    </div>
  </v-card>
</template>

<script>
const moment = require("moment");

import { stripPackTitlePrefix } from "@/lib/formatters";

export default {
  name: "PackQuickLinks",
  computed: {
    filteredPackList() {
      const filteredList = this.packList.filter(({ productionDate }) => {
        return Date.parse(productionDate) ? this.withinLastTwelveMonths(productionDate) : false;
      });
      return filteredList;
    },
    linkName() {
      return this.user.isOchinUser ? "releaseNote" : "testPlan";
    },
    packListCritical() {
      const {
        packTypeMap: { critical: filterTypeList },
      } = this;

      return this.filteredPackList.filter(({ type }) => filterTypeList.includes(type));
    },
    packListOther() {
      const {
        packTypeMap: { critical: criticalTypeList, releaseCycle: releaseCycleTypeList },
      } = this;
      const filterTypeExcludeList = [...criticalTypeList, ...releaseCycleTypeList];

      return this.filteredPackList.filter(({ type }) => !filterTypeExcludeList.includes(type));
    },
    packListReleaseCycle() {
      const {
        packTypeMap: { releaseCycle: filterTypeList },
      } = this;

      return this.filteredPackList.filter(({ type }) => filterTypeList.includes(type));
    },
    user() {
      return this.$store.state.session.user;
    },
  },
  data() {
    return {
      packTypeMap: {
        critical: ["Critical Fix"],
        releaseCycle: ["Enhancement Pack", "Service Pack"],
      },
      stripPackTitlePrefix: stripPackTitlePrefix,
    };
  },
  methods: {
    withinLastTwelveMonths(date) {
      const DATE_FORMAT = "YYYY-MM-DD";
      const currentDate = moment();
      const productionDate = moment(date).format(DATE_FORMAT);
      const endOfCurrentMonth = currentDate.endOf("month").format(DATE_FORMAT);
      const startOfTwelfthMonthPast = currentDate
        .subtract(12, "M")
        .startOf("month")
        .format(DATE_FORMAT);

      return moment(productionDate).isBetween(startOfTwelfthMonthPast, endOfCurrentMonth);
    },
  },
  props: {
    packList: {
      type: Array,
      required: true,
    },
  },
};
</script>
